// LeadCardWrapper.js
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Box } from '@chakra-ui/react';
import LeadCard from './LeadCard';

const LeadCardWrapper = ({ lead, index, onEdit, onAdvancedEdit }) => {
  // Create a unique key that includes the follow-up time AND a timestamp to force re-renders when it changes
  const uniqueKey = `${lead.leadId}-${lead.nextFollowUpTime || 'none'}-${Date.now()}`;
  
  console.log('[LeadCardWrapper] Rendering with unique key:', {
    leadId: lead.leadId,
    uniqueKey,
    nextFollowUpTime: lead.nextFollowUpTime
  });

  return (
  <Draggable
    key={uniqueKey}
    draggableId={lead.leadId}
    index={index}
    isDragDisabled={false}
  >
    {(provided, snapshot) => (
      <Box
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        opacity={snapshot.isDragging ? 0.8 : 1}
        transform={snapshot.isDragging ? 'rotate(3deg)' : ''}
        boxShadow={snapshot.isDragging ? 'lg' : ''}
        zIndex={snapshot.isDragging ? 100 : 1}
      >
        <LeadCard
          lead={lead}
          onEdit={onEdit}
          onAdvancedEdit={onAdvancedEdit}
        />
      </Box>
    )}
  </Draggable>
);
};

export default LeadCardWrapper;
